export default {
  type: 'cards',
  help: 'Present info in a visual card layout',
  title: 'Cards',
  icon: 'cards',
  inline_edits: false,
  schema: {
    cards: {
      type: 'Hidden',
      default: [],
    },
  },
};
